/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Fact_NextInputs */

const en_services_fact_next = /** @type {(inputs: Services_Fact_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next open`)
};

const pl_services_fact_next = /** @type {(inputs: Services_Fact_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbliższy wolny`)
};

/**
* | output |
* | --- |
* | "Next open" |
*
* @param {Services_Fact_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_fact_next = /** @type {((inputs?: Services_Fact_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Fact_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_fact_next(inputs)
	return en_services_fact_next(inputs)
});